import { axiosRequest } from '@/util/axios-request';
export function login(data) {
  return axiosRequest({
    url: '/user/login',
    method: 'post',
    data: data
  });
}
export function userLogin(data) {
  return axiosRequest({
    url: '/auth/user/login',
    data: data
  });
}
export function fetchPermissionList() {
  return axiosRequest({
    url: '/auth/user/my',
    method: 'get'
  });
}
export function apiGetPermissionAll(params) {
  return axiosRequest({
    url: '/user/permission/all',
    method: 'get',
    params: params
  });
}
export function apiGetPermissionList(params) {
  return axiosRequest({
    url: '/user/permission/list',
    method: 'get',
    params: params
  });
}
export function apiSetPermission(data) {
  return axiosRequest({
    url: '/user/permission/grant',
    data: data
  });
}
export function getInfo(token) {
  return axiosRequest({
    url: '/user/info',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout() {
  return axiosRequest({
    url: '/user/logout',
    method: 'post'
  });
}